function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11557",
  "data-name": "Path 11557",
  d: "M19.62,4.77a1.26,1.26,0,0,0-1.26-1.26H15.84V2.25H14.58V3.51H9.54V2.25H8.28V3.51H5.76A1.26,1.26,0,0,0,4.5,4.77v12.6a1.26,1.26,0,0,0,1.26,1.26H8.28V17.37H5.76V4.77H8.28V6.03H9.54V4.77h5.04V6.03h1.26V4.77h2.52V8.55h1.26Z",
  transform: "translate(-4.5 -2.25)",
  fill: "#ac1ede"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11558",
  "data-name": "Path 11558",
  d: "M19.665,16.875l1.606,3.111,3.434.5-2.52,2.421.63,3.419-3.15-1.614-3.15,1.614.63-3.419-2.52-2.421,3.528-.5Z",
  transform: "translate(-8.955 -8.685)",
  fill: "#ac1ede"
});

var SvgEvent = function SvgEvent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "event",
    width: 15.75,
    height: 17.64,
    viewBox: "0 0 15.75 17.64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEvent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/event.aef415c4.svg";
export { ForwardRef as ReactComponent };